document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-product-root]');
  if (root) {
    const mainImage = root.querySelector('#forge-main-image');
    root.querySelectorAll('.forge-thumb').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('.forge-thumb').forEach((thumb) => thumb.classList.toggle('active', thumb === button));
        mainImage.src = button.dataset.image;
        mainImage.alt = button.dataset.alt;
      });
    });

    const placeBundleBeforeCart = () => {
      const form = root.querySelector('.forge-product-form');
      const addButton = root.querySelector('.forge-buy');
      if (!form || !addButton) return false;

      const title = Array.from(document.querySelectorAll('body *')).find((element) =>
        element.children.length === 0 && element.textContent.trim() === 'Choose Your FORGE K9 System'
      );
      if (!title) return false;

      let widget = title;
      for (let depth = 0; depth < 8 && widget.parentElement; depth += 1) {
        const parent = widget.parentElement;
        const text = parent.textContent || '';
        if (text.includes('1 System') && text.includes('2 Systems') && text.includes('3 Systems')) {
          widget = parent;
          break;
        }
        widget = parent;
      }

      if (widget === root || widget.contains(form)) return false;

      // Revy's styles depend on the widget staying inside the wrapper it creates.
      // Keep that DOM untouched and move only our submit button below the widget.
      addButton.setAttribute('form', form.getAttribute('id'));
      widget.insertAdjacentElement('afterend', addButton);
      return true;
    };

    if (!placeBundleBeforeCart()) {
      const bundleObserver = new MutationObserver(() => {
        if (placeBundleBeforeCart()) bundleObserver.disconnect();
      });
      bundleObserver.observe(root, { childList: true, subtree: true });
    }
  }
});
